// questionPaperGeneratorSvc.js
import axios from 'axios';
import lstModules from 'common/json/lstModules.json';

// Node backend (Question Paper Generator + Gemini) — COMMENTED OUT, ab Java backend use ho raha hai
// const nodeURL = 'http://localhost:5000';

// Java backend (Spring Boot — Question Paper Generator + Gemini) on port 8080
// Same endpoints as Node: /api/subjects, /api/chapters, /api/generate
// localhost phone pe phone khud ko point karta hai — isliye PC ka LAN IP
// const nodeURL = 'http://localhost:8080';
const nodeURL = 'http://10.65.2.213:8080';

// Java backend (existing) - used only to fetch the saved patterns + their sections
const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;

// DEMO: hardcoded prod tokenid (login bypass). Expire hone par naya daalna padega.
const DEMO_TOKEN = 'em8w04f5d3o196n4slngsl21wvi6b8';
export function getTokenId() { return localStorage.getItem('tokenid') || DEMO_TOKEN; }

/* ----------------------- NODE BACKEND ----------------------- */

export const getSubjectListSvc = (cb) => {
    axios.get(nodeURL + '/api/subjects')
        .then((r) => cb({ status: r.data.status, lstSubject: r.data.lstSubject }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};

// Class list — REAL prod (DEMO_TOKEN se auth)
export const getClassListSvc = (cb) => {
    axios({
        url: httpURL + '/sms/mst/cls/list',
        method: 'POST',
        params: { screenId: 1 },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb({ status: r.data.SvcStatus, lstClass: r.data.lstClass, message: r.data.SvcMsg }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};

export const getChapterListSvc = (clsId, subjectId, cb) => {
    axios.get(nodeURL + '/api/chapters', { params: { clsId, subjectId } })
        .then((r) => cb({ status: r.data.status, lstChapter: r.data.lstChapter }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};

// REAL generate — backend (Gemini) se actual question paper
export const generatePaperSvc = (payload, cb) => {
    axios.post(nodeURL + '/api/generate', payload)
        .then((r) => cb(r.data))
        .catch((e) => cb({ status: 'Exception', message: (e.response && e.response.data && e.response.data.message) || e.message }));
};

/* ----------------------- JAVA BACKEND (reuse) ----------------------- */

// Pattern list — REAL prod (DEMO_TOKEN se auth)
export const getQpPatternListSvc = (clsId, cb) => {
    axios({
        url: httpURL + '/sms/qp_pattern/list',
        method: 'POST',
        params: { clsId },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb({ status: r.data.SvcStatus, lstPattern: r.data.lstQpPattern, message: r.data.SvcMsg }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};

// Pattern sections — REAL prod (DEMO_TOKEN se auth)
export const getPatternSectionListSvc = (patternId, cb) => {
    axios({
        url: httpURL + '/sms/qp_pattern/list_pattern_section',
        method: 'POST',
        params: { patternId },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb({ status: r.data.SvcStatus, lstPatternSection: r.data.lstQpPatternSection, message: r.data.SvcMsg }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};
